<template>
  <header class="booking__header">
    <!--Navbar-->
    <b-navbar id="nav" toggleable="lg" type="light">
      <b-container class="justify-content-center">
        <b-navbar-brand aria-role="nav" aria-label="Navigate back to boxx.ie">
          <button class="booking__header__brand" @click="goBack('/')">
            <img
              class="booking__header__logo booking__header__logo--xs"
              src="@/assets/img/logo/boxx-mini-black.svg"
              alt="Boxx Barber Shop logo"
            />
            <img
              class="booking__header__logo booking__header__logo--lg"
              src="@/assets/img/logo/logo.jpg"
              alt="Boxx Barber Shop logo"
            />
          </button>
        </b-navbar-brand>
      </b-container>
    </b-navbar>
  </header>
</template>
<script>
import { goBack } from '@/mixins';
export default {
  mixins: [goBack]
};
</script>
